import React, { useState } from "react";
import {
  Autocomplete,
  Button,
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  TextField,
} from "@mui/material";

import { FORM_STYLES, L_GRID_PROPS, S_GRID_PROPS } from "../../constants";

interface MisdeliveryF18NoteInlineFormProps {
  msdPro: number[];
  proOptions: number[];
  note: string;
  onMsdProChange: (value: number[]) => void;
  onNoteChange: (value: string) => void;
  onCancelF18Note?: () => void;
  onSubmitF18Note?: () => void;
  onEdit?: () => void;
  readOnly?: boolean;
}

const MisdeliveryF18NoteInlineForm: React.FC<MisdeliveryF18NoteInlineFormProps> = ({
  msdPro,
  proOptions,
  note,
  onMsdProChange,
  onNoteChange,
  onCancelF18Note,
  onSubmitF18Note,
  onEdit,
  readOnly = false,
}) => {
  const [inputValue, setInputValue] = useState("");

  return (
    <Grid container spacing={2} className="filter-margin">
      <Grid item {...S_GRID_PROPS}>
        <FormControl fullWidth size="small">
          <InputLabel htmlFor="msdPro" style={FORM_STYLES.LABEL} shrink>
            Pro# <sup>*</sup>
          </InputLabel>
          <Autocomplete
            id="msdPro"
            disablePortal
            className="custom-autocomplete"
            multiple
            disabled={readOnly}
            forcePopupIcon={false}
            getOptionLabel={(option) => option.toString()}
            disableCloseOnSelect
            value={msdPro}
            style={FORM_STYLES.LABEL}
            options={proOptions}
            onChange={(_, value) => {
              onMsdProChange(value);
              setInputValue("");
            }}
            inputValue={inputValue}
            onClose={() => {
              setInputValue("");
            }}
            onInputChange={(_, value, reason) => {
              if (reason === "input") {
                setInputValue(value);
              }
            }}
            renderOption={(optionProps, option) => {
              const { key, ...liProps } = optionProps as React.HTMLAttributes<HTMLLIElement> & { key: React.Key };

              return (
                <li key={key} {...liProps} title={option.toString()}>
                  <Checkbox checked={msdPro.includes(option)} />
                  {option}
                </li>
              );
            }}
            renderInput={(params) => (
              <TextField autoComplete="off" {...params} variant="outlined" />
            )}
            renderTags={(value) => (
              <div
                className="auto-complete-selected-container"
                title={value.join(", ")}
              >
                {value.join(", ")}
              </div>
            )}
          />
        </FormControl>
      </Grid>

      <Grid item {...L_GRID_PROPS}>
        <FormControl fullWidth size="small">
          <InputLabel htmlFor="msdNote" style={FORM_STYLES.LABEL} shrink>
           F18 Note
          </InputLabel>
          <TextField
            autoComplete="off"
            id="msdNote"
            placeholder="Enter F18 note"
            variant="outlined"
            value={note}
            disabled={readOnly}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              onNoteChange(event.target.value)
            }
            multiline
            rows={2}
          />
        </FormControl>
      </Grid>

      {readOnly && onEdit && (
        <Grid item xs={12} className="btn-group-submit">
          <Button
            type="button"
            variant="contained"
            className="assign mr-0 ml"
            onClick={onEdit}
          >
            Edit F18 Note
          </Button>
        </Grid>
      )}
      {!readOnly && (
        <Grid item xs={12} className="btn-group-submit">
          <Button
            type="button"
            variant="contained"
            className="clear-btn mr-0 ml"
            onClick={onCancelF18Note}
          >
            Cancel
          </Button>

          <Button
            type="button"
            variant="contained"
            className="entry ml"
            onClick={onSubmitF18Note}
          >
            Submit F18 Note
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default MisdeliveryF18NoteInlineForm;
